// Statuts d'abonnement — miroir du fichier serveur
// Pour ajouter un statut : ajouter ici + côté serveur
import i18next from "i18next";

export const SUBSCRIPTION_STATUSES = {
  ACTIVE:          1,
  INACTIVE:        0,
  PAYMENT_PENDING: 2,
};

const STATUS_LABEL_KEYS = {
  [SUBSCRIPTION_STATUSES.ACTIVE]:          "subscription.status_active",
  [SUBSCRIPTION_STATUSES.INACTIVE]:        "subscription.status_inactive",
  [SUBSCRIPTION_STATUSES.PAYMENT_PENDING]: "subscription.status_payment_pending",
};

export const getStatusLabel = (status) => i18next.t(STATUS_LABEL_KEYS[status] || "subscription.unknown_status");

export const getStatusOptions = () =>
  Object.entries(SUBSCRIPTION_STATUSES).map(
    ([key, value]) => ({ key, value, label: getStatusLabel(value) })
  );
